import { Component, OnInit, ViewChild } from '@angular/core';
import { OnboardingService } from '@boxx/onboarding-core/lib/services/onboarding.service';
import { IonSearchbar, PopoverController } from '@ionic/angular';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Component({
  selector: 'app-custom-category-picker',
  templateUrl: 'custom-category-picker.component.html',
  styleUrls: ['./custom-category-picker.page.scss']
})
export class CustomCategoryPickerComponent implements OnInit {
  @ViewChild('categoryPickerSB', { static: false })
  searchBar: IonSearchbar;
  searchResults: Array<{ id: string; template_name: string }> = [];
  searchFullResults: Array<{ id: string; template_name: string }> = [];
  noResultsFound = false;
  isLoading = false;
  searchFilter = '';

  constructor(
    public popoverController: PopoverController,
    private service: OnboardingService,
    private boxxUtils: BoxxUtilsService
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 800);
    this.loadTemplates();
  }

  loadTemplates(){
    this.searchResults = [];
    this.noResultsFound = false;
    this.isLoading = true;
    this.service.getTemplates('').subscribe(
      (result) => {
        if (result && result.length > 0) {
          const dataResult = result.sort( ( a, b ) => {
            a = a.template_name.toLowerCase();
            b = b.template_name.toLowerCase();
            return a < b ? -1 : a > b ? 1 : 0;
          });
          this.searchResults = dataResult;
          this.searchFullResults = dataResult;
        }

        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.boxxUtils.showToastError({
          message: 'Hubo un error en la búsqueda, intente nuevamente',
        });
      }
    );
  }

  search(ev: any) {
    const searchTerm = ev.detail.value;
    
    if (!searchTerm) {
      this.searchResults = this.searchFullResults;
      return;
    }
  
    this.searchResults = this.searchResults.filter(
      (item) =>
        item.template_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
    );
  }

  selectActivity(activity: any) {
    this.popoverController.dismiss({
      data: activity
    });
  }
  
  close(){
    this.popoverController.dismiss();
  }
}